import { useRouter } from "next/router";
import React, { useContext, useEffect } from "react";
import { format } from "date-fns";
import { toast } from "react-toastify";

import useCart from "../../hooks/services/useCart.hook";
import posIcons from "../../icons/pos.icons";
import { RootStateContext } from "../../states/root.state";
import { useTranslation } from "../../core/translation.core";
import ArrowDownIcon from "../../icons/arrowdown.icon";
import XMarkIcon from "../../icons/xMark.icon";

export default function HeldCartPanel() {
  const { listHeldCarts } = useCart();
  const { push } = useRouter();
  const { t, msg } = useTranslation();

  function handleCartSwitch() {
    push(`/?cartOpen=true`);
  }

  return (
    <div className="p-3 h-[91vh] w-[97%] space-y-8 bg-white dark:bg-her-darkblue2 dark:text-white">
      <button onClick={handleCartSwitch} className="flex gap-4 items-center ">
        <span>
          <svg width="12" height="21" viewBox="0 0 12 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 20.5L0 10.5L10 0.5L11.775 2.275L3.55 10.5L11.775 18.725L10 20.5Z" fill="currentColor" />
          </svg>
        </span>

        <h1 className="text-2xl">{t(msg.pos.viewHeldCart)}</h1>
      </button>

      {/* @ts-ignore */}
      {listHeldCarts?.data?.length > 0 ? (
        <section className="space-y-6">
          {listHeldCarts?.data?.map((c, idx) => (
            <CartItem key={idx} {...c} />
          ))}
        </section>
      ) : (
        <div className="flex-center h-full">{posIcons.emptyCartIcon}</div>
      )}
    </div>
  );
}

function CartItem(item: any) {
  const { deleteCart, updateHeldCartStatusToActive } = useCart();
  const { checkoutService } = useContext(RootStateContext);
  const [showProducts, setShowProducts] = React.useState(false);
  const router = useRouter();
  const { t, msg } = useTranslation();

  async function handleDeleteCart() {
    deleteCart.mutate(item.id);
  }

  async function activeCartFn() {
    checkoutService.send({
      type: "RESET_XSTATE",
    });

    checkoutService.send({
      customer: item.customerInfo,
      type: "ASSIGN_CUSTOMER",
    });

    await updateHeldCartStatusToActive.mutate({
      cartId: item.id,
      customerId: item.customerInfo.id,
    });
  }

  useEffect(() => {
    if (updateHeldCartStatusToActive.error) {
      toast.error(updateHeldCartStatusToActive.error.toString());
      updateHeldCartStatusToActive.reset();
    }

    if (updateHeldCartStatusToActive.isSuccess) {
      updateHeldCartStatusToActive.reset();

      router.push("/");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateHeldCartStatusToActive.error, updateHeldCartStatusToActive.isSuccess]);

  function handleShowProducts() {
    setShowProducts(!showProducts);
  }

  return (
    <section className="bg-her-lightgray dark:bg-her-backblue dark:text-white shadow-md p-3 rounded-md">
      <h1>{format(item.date, "yyyy-MM-dd, HH:mm")}</h1>

      <div className="flex-btw space-y-4">
        <div className="text-sm space-y-4">
          <h4 className="font-bold">
            {t(msg.pos.cart)}: {item.items.length} {item.items.length > 1 ? t(msg.pos.items) : t(msg.pos.item)}
          </h4>

          <p>
            {t(msg.pos.customer)} : {item?.customerInfo?.name}
          </p>
        </div>

        <div className="flex flex-col items-center space-y-4">
          <button
            onClick={handleDeleteCart}
            className="rounded-md font-light text-sm p-1.5 bg-white dark:bg-her-darkblue2 dark:text-white flex items-center gap-3"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>

          <button onClick={activeCartFn} className="btn-recover-cart bg-blue-600 px-2 py-1 text-sm rounded-sm shadow-sm">
            {t(msg.pos.recover)}
          </button>
        </div>
      </div>

      <div className="space-y-3">
        <div onClick={handleShowProducts} className="flex gap-2 items-center cursor-pointer">
          <button>{t(msg.pos.showProducts)}</button>
          <ArrowDownIcon />
        </div>

        {showProducts && (
          <div>
            {item.items.map((i: any, idx: number) => (
              <div key={idx} className="flex-btw p-3 border-b border-gray-200">
                <div className="flex gap-4">
                  <h4 className="text-sm">{i.product.name}</h4>
                  <p>{i.product.price}</p>
                </div>

                <div>
                  <p>X{i.quantity}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
